(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('ViewCampaignMenuController', ViewCampaignMenuController);

    /** @ngInject */
    function ViewCampaignMenuController(CampaignService, $uibModalInstance, campaign, isHub, $uibModal) {
        var vm = this;

        vm.campaign = null;
        vm.totalActivities = 0;
        vm.totalActivitiesFinished = 0;
        vm.percentage = 0;
        vm.sellers = [];
        vm.isHub = angular.copy(isHub);

        vm.close = function () {
            $uibModalInstance.close();
        };

        function calculatePercentage(done, total) {
            return total > 0 ? ((done / total) * 100).toFixed(0) : '0';
        }

        vm.onInit = function () {
            CampaignService.get(campaign.id).then(function (result) {
                vm.campaign = result.data.campaign;
                vm.sellers = result.data.sellers;
                vm.totalActivities = result.data.totalActivities;
                vm.totalActivitiesFinished = result.data.totalActivitiesFinished;
                vm.percentage = calculatePercentage(vm.totalActivitiesFinished, vm.totalActivities);
            });
        };

        vm.openViewTargetAudienceMenu = function () {
            $uibModalInstance.close();


            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/create-target-audience/create-target-audience.html',
                controller: 'CreateTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal full-screen-modal',
                backdrop: 'static',
                resolve: {

                    targetAudienceId: function () {
                        return vm.campaign.targetAudienceId;
                    },
                    isViewMode: function () {
                        return true;
                    }
                }
            }).result.then(function (createdItem) {
                vm.reOpenViewCampaignMenu();
            });
        };

        vm.reOpenViewCampaignMenu = function (campaign) {
            return $uibModal.open({
                templateUrl: 'app/admin/campaign/view-campaign/view-campaign.html',
                controller: 'ViewCampaignMenuController',
                controllerAs: 'vm',
                windowClass: 'modal-side-menu',
                backdrop: 'static',
                resolve: {
                    campaign: function () {
                        return vm.campaign;
                    },
                    isHub: function () {
                        return vm.isHub;
                    }
                }
            }).result.then();
        };


    }
})();
